import { IDirectOrder } from '@alberta/konexi-shared';
import { Inject, Injectable, NgZone } from '@angular/core';
import { DirectOrderChannel } from 'src/app/business/direct-order/contracts/direct-oder-channel';
import { IAppController } from 'src/app/common/contracts/controller/app-controller';
import { IDispatcher } from 'src/app/common/contracts/dispatch/dispatcher';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';
import { AppController } from 'src/app/common/controller/app-controller';
import { Dispatcher } from 'src/app/common/dispatch/dispatcher';

import { DirectOrderModelName } from '../../models/model-names';
import { SyncProgressEvent } from '../../models/sync-progress-event';
import { EventService } from '../event.service';
import { SyncService } from './sync.service';

@Injectable()
export class DirectOrderSyncService extends SyncService<IDirectOrder> {
  constructor(
    @Inject(AppController) appController: IAppController,
    @Inject(Dispatcher) dispatcher: IDispatcher<IDirectOrder>,
    eventService: EventService<SyncProgressEvent>,
    ngZone: NgZone,
    @Inject(PlatformSyncToken) platformSync: IPlatformSync
  ) {
    super(DirectOrderModelName, appController, dispatcher, eventService, ngZone, platformSync);
  }

  protected async afterPatch(entity: IDirectOrder): Promise<void> {
    this.onPatched(entity);
  }

  public canSync(channel: string): boolean {
    return (
      channel === DirectOrderChannel.CREATE ||
      channel === DirectOrderChannel.EDIT ||
      channel === DirectOrderChannel.DELETE
    );
  }
}
